<template>
  <div>
    <div class="page-search-block">
      <div class="search-bar">
        <!-- <span class="w-90 inline-block align-r m-r-8">高级筛选：</span> -->

        <div class="m-b-18 inline-block">
          <span class="w-80 inline-block align-r m-r-8">门铃编码：</span>
          <el-input class="w-100 m-r-8" v-model="filters.search.deviceCodeLike" placeholder="请输入" ></el-input>
        </div>

        <div class="m-b-18 inline-block">
          <el-select v-model="filters.search.selLabelTypeRoom" class="select-as-label w-100 m-r-8">
            <el-option key="rom1" value="roomName" label="房源名称"></el-option>
            <el-option key="rom2" value="roomCode" label="房源编码"></el-option>
          </el-select>
          <el-input class="w-120 m-r-8" v-model="filters.search.roomValue" placeholder="请输入" ></el-input>
        </div>

        <div class="m-b-18 inline-block">
          <span class="w-90 inline-block align-r m-r-8">抓拍时间：</span>
          <el-date-picker
              class="m-r-8"
              style="width:240px;"
              v-model="filters.search.captureTime"
              type="daterange"
              range-separator="~"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
            >
            </el-date-picker>
        </div>

        <el-button class="submit-btn" size="large" @click="handleSearch()">搜 索</el-button>

      </div>
    </div>

    <div class="page-operate-block"><div class="tit">门铃日志列表</div></div>




    <div v-if="imgsData.length" class="doorbell-img-content  table-list-block">
      <div class="imgs-container">
        <div class="content-item" v-for="item in imgsData" :key="item.id">
          <div class="img-line">
            <div class="img-item">
              <el-image class="img" :src="item.faceUrl" fit="cover" :preview-src-list="[item.faceUrl]">
              </el-image>
              <span>人脸照片</span>
            </div>
            <div class="img-item img-item-mid">
              <el-image class="img" :src="item.faceBgUrl" fit="cover" :preview-src-list="[item.faceBgUrl]">
              </el-image>
              <span>背景照片</span>
            </div>
            <div class="img-item">
              <div class="img-item-line">
                <span class="img-item-label">抓拍时间：</span>
                <span class="img-item-content">{{ item.captureTime }}</span>
              </div>
              <div class="img-item-line">
                <span class="img-item-label">门铃编码：</span>
                <span class="img-item-content">{{ item.deviceCode }}</span>
              </div>
              <div class="img-item-line">
                <span class="img-item-label">房源名称：</span>
                <span class="img-item-content">{{ item.roomName ? item.roomName:'--'}}</span>
              </div>
              <div class="img-item-line">
                <span class="img-item-label">房源编码：</span>
                <el-tooltip :content="item.roomCode" effect="light">
                  <div class="img-item-content ellipsis-text">
                    {{ item.roomCode ? ''+item.roomCode:'--' }}
                  </div>
                </el-tooltip>
              </div>
              <div class="img-item-line">
                <span class="img-item-label">房源地址：</span>
                <el-tooltip :content="item.roomAddress" effect="light">
                  <div class="img-item-content ellipsis-text">
                    {{ item.roomAddress ? item.roomAddress:'--'}}
                  </div>
                </el-tooltip>
              </div>
              
            </div>
          </div>
        </div>
       <!-- <div class="ghost-item" v-for="i in 4" :key="'g_' + i"></div> -->
      </div>
      <RPagination class="img-pagination" :pagination="pagination" @current-change="handlePageChange" />
    </div>
    <div v-else class="table-list-block empty-text">
      暂无数据
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import RPagination from '@/components/common/RPagination'
import tableMix from '@/components/common/tableListMixin.js'

export default {
  name: 'equipDoorbellLogPage',
  components: { RPagination },
  mixins: [tableMix],
  props: {
    deviceCode: { type: [String, Number], default: '' },
  },
  data() {
    let searchData = { 'deviceCodeLike':'',selLabelTypeRoom:'roomName',roomValue:'',captureTime:''}
    return {
      filters: { search: {...searchData} },
      filtersInitSearchData:{...searchData},
      imgsData: [],
      pagination: {
        pageIndex: 1,
        pageSize: 20,
        total: 0
      }
    }
  },
  beforeUnmount() {
    this.$eventBus.off('change-shop')
  },
  created() {
    this.$eventBus.on('change-shop', store => {
      this.handleSearch()
    })
    this.getDataList()
  },
  methods: {
    ...mapActions(['fetchData']),
    // 查询列表数据
    getQuery() {
      let params = this.getQueryListParams()
      if(params.selLabelTypeRoom && params.roomValue){
        params[params.selLabelTypeRoom] = params.roomValue
      }
      if(params.captureTime && params.captureTime[0]){
        params.startTime = params.captureTime[0]
        params.endTime = params.captureTime[1]
      }

      let curStoreInfo = this.getCurStoreInfo()
      if(curStoreInfo && curStoreInfo.id){
        params['storeId'] = curStoreInfo.id
      }
      
      delete params.captureTime
      delete params.selLabelTypeRoom
      delete params.roomValue

      let url = 'DEVICE.GET_CAPTURE_LIST'
      this.fetchData({ url, method: 'get', params }).then((res) => {
        this.imgsData = res.data || []
        this.pagination.total = res ? res.rowCount : 0
      })
    },
    // 返回
    backToBell() {
      this.$emit('change-view')
    },
    // 页码组件数据变动
    handlePageChange(index, size) {
      this.pagination.pageIndex = index
      this.pagination.pageSize = size
      this.getQuery()
    }
  },
}
</script>

<style lang="less" scoped>
@defaultColor: #909399;
@itemWidth: 550px;
.el-form-item{
  width: 300px !important;
}
.log-title {
  font-size: 22px;
  font-weight: 600;
  color: #333;
}
.topDiv {
  padding: 10px 40px 0px 40px;
}
.doorbell-img-content {
  position: relative;
  padding: 10px 40px;
  width: 100%;
  height: calc(~"100vh - 140px");
  font-size: 12px;
  color:#7d7d7d;
  .page-title {
    margin-bottom: 10px;
    color: @defaultColor;
  }
  .img-pagination {
    position: absolute;
    bottom: 0px;
    padding: unset;
    width: calc(~"100% - 80px");
  }
  .imgs-container {
    min-height: 280px;
    max-height: calc(~"100vh - 190px");
    position: relative;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .content-item {
      position: relative;
      margin-bottom: 15px;
      padding: 10px 15px;
      width: 33%;
      height: 170px;
      border: 1px solid #DCDFE6;
      border-radius: 2px;
    }
    .img-line {
      display: flex;
      align-content: center;
      justify-content: space-between;
    }
    .img-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      &:last-of-type {
        margin-left: 10px;
      }
      .img {
        max-width: 105px;
        height: 98px;
      }
      span {
        margin-top: 5px;
        margin-bottom: 5px;
        color: @defaultColor;
      }
    }
    .img-item-line{
      width: 100%;
      text-align: left;
    }
    .img-item-mid{
      padding: 0 10px;
    }
    .img-item-label{
      color: #585858 !important;
      font-size: 14px;
    }
    .img-item-content{
      color:#000000 !important;
      font-size: 14px;
    }
    .img-desc {
      color: @defaultColor;
    }
    .ghost-item {
      width: @itemWidth;
    }
  }
}
.empty-text {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;
  font-size: 22px;
  color: @defaultColor;
}
.ellipsis-text{
  width: 100px;
  text-overflow:ellipsis !important; 
  overflow:hidden !important;  
  white-space:nowrap !important;
  word-wrap: break-word;
  word-break: break-all;
  display: inline-block;
}
</style>
